import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  half?: 'right' | 'left'
}
const ChartWrapper = ({ children, half }: Props) => {
  return (
    <div
      className={clsx(
        half == 'left'
          ? 'w-1/2 py-4 pr-2 pl-4'
          : half == 'right'
            ? 'w-1/2 py-4 pr-4 pl-2'
            : 'w-full p-4'
      )}
    >
      <div className='bg-fill-surface-secondary relative h-65 w-full min-w-0 rounded-lg px-4 py-3'>
        {children}
      </div>
    </div>
  )
}

export default ChartWrapper
